/**
 * Copyright © IMPACT Commerce AB. All rights reserved.
 * See COPYING.txt for license details.
 */

/*
 * Toggles `.is-pinned` on the master filter tabs the moment they reach their sticky line
 * (just under the header). The header-coupled slide animation in master-filter-tabs.liquid
 * is gated on that class, so it only runs while the bar is actually pinned — never while it
 * is still in normal flow, which used to lift it up over the collection title.
 *
 * One global, passive, rAF-throttled scroll listener that re-queries the bar each tick, so
 * it keeps working after the results section re-renders (filtering) without re-binding.
 */
(() => {
  if (window.__masterFilterTabsPinInit) return;
  window.__masterFilterTabsPinInit = true;

  let ticking = false;

  const update = () => {
    ticking = false;

    const nav = document.querySelector('.master-filter-tabs');
    const anchor = nav?.parentElement;
    if (!nav || !anchor) return;

    const headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;

    // `anchor` (the collection wrapper) is never transformed, so its top edge tracks the
    // bar's natural, pre-sticky position. Once it crosses the sticky line the bar is pinned.
    const pinned = anchor.getBoundingClientRect().top <= headerHeight;
    nav.classList.toggle('is-pinned', pinned);
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  document.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
